












import Popup from '@/views/organisms/Popup.vue'
import ApiClient from '@/common/api'
import store from '@/store'
import TextArea from '@/views/atoms/TextArea.vue'

export default
  components: {
    Popup
    TextArea
  }

  props:
    remarks1:
      type: String
      default: ''
    remarks2:
      type: String
      default: ''

  methods: {
    close_popup: (e) ->
      @$emit('close_popup')
  }
